<template>
  <div>
    <span class="search-form__yen-mark">¥</span>
    <input
      v-model.number="value"
      type="number"
      :class="{
        'input-form--min': !isInputted,
        'input-form--min--inputted': isInputted
      }"
      :placeholder="placeholder"
      @input="onInput"
    />
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: true
    },
    defaultValue: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    }
  },
  data() {
    return {
      value: null
    }
  },
  computed: {
    isInputted() {
      return this.value !== null
    }
  },
  mounted() {
    this.value = this.defaultValue
  },
  methods: {
    onInput() {
      this.$emit('inputted', this.value ? this.value : null)
    }
  }
}
</script>
